import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Privacy() {
  return (
    <main className="min-h-screen py-12 px-4 md:px-8">
      <div className="max-w-3xl mx-auto">
        <Link
          to="/"
          data-testid="privacy-back-link"
          className="inline-flex items-center gap-2 text-sm text-kawaii-textSoft hover:text-kawaii-text mb-8 font-body"
        >
          <ArrowLeft className="w-4 h-4" strokeWidth={2.5} />
          Back to my calendar
        </Link>

        <header className="mb-10">
          <p className="text-[10px] uppercase tracking-[0.3em] text-kawaii-textSoft font-bold">Legal</p>
          <h1 className="font-heading text-4xl md:text-5xl text-kawaii-text mt-2">Privacy Policy</h1>
          <p className="text-xs text-kawaii-textSoft mt-3 font-body">Last updated: July 2026</p>
        </header>

        <article className="kawaii-card p-8 md:p-10 space-y-8 font-body text-kawaii-text leading-relaxed">
          <section>
            <h2 className="font-heading text-xl text-kawaii-text mb-3">Storage</h2>
            <p className="text-sm">
              Your data is stored in a <strong>private MongoDB database</strong> created specifically for this app
              when it was deployed. Uploaded photos and videos are stored in an object-storage bucket dedicated to this app.
              No other app or user has access to your database or bucket.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl text-kawaii-text mb-3">What we collect</h2>
            <ul className="text-sm list-disc pl-6 space-y-1">
              <li>Account info: your name and email address.</li>
              <li>Health-tracking content you enter: journal entries, symptoms, self-care, mood, photos and videos.</li>
              <li>Payment metadata (via Stripe) if you subscribe or donate — we <strong>never</strong> see or store your card details.</li>
              <li>Minimal technical logs (request timestamps, error traces) used solely to keep the app running.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-xl text-kawaii-text mb-3">What we do <em>not</em> do</h2>
            <ul className="text-sm list-disc pl-6 space-y-1">
              <li>We do not sell your personal information — full stop.</li>
              <li>We do not share your data with third-party advertisers or data brokers.</li>
              <li>We do not use your health content to train general AI models without your explicit consent.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-xl text-kawaii-text mb-3">AI features</h2>
            <p className="text-sm">
              When you use Lymphie chat, end-of-day summaries, or the Emergency script, your text is sent to our AI provider
              (Anthropic Claude) to generate a response. Providers process content ephemerally and do not train on it
              under our commercial API agreement. No photos or videos are ever sent to AI providers.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl text-kawaii-text mb-3">Proprietary code</h2>
            <p className="text-sm">
              The code that runs this app is yours. It is not used to train general AI models without your consent.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl text-kawaii-text mb-3">Your rights</h2>
            <p className="text-sm">
              You may export your monthly PDF at any time, delete individual entries from the calendar, and request full account
              deletion by emailing{" "}
              <a href="mailto:hello@letscure.app" className="underline underline-offset-2">hello@letscure.app</a>.
              Deletion removes all journal entries, photos, videos, and account records within 30 days.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl text-kawaii-text mb-3">Contact</h2>
            <p className="text-sm">
              For privacy questions, email{" "}
              <a href="mailto:hello@letscure.app" className="underline underline-offset-2">hello@letscure.app</a>.
            </p>
          </section>
        </article>
      </div>
    </main>
  );
}
